export enum DeliveryStatus {
    Open        = 0,
    Completed   = 1,
    Invoiced    = 2
}

export const DeliveryStatusMetadata = {
    '0': {
        display: 'Open',
        value: 0
    },
    '1': {
        display: 'Completed',
        value: 1
    },
    '2': {
        display: 'Invoiced',
        value: 2
    }
};
